import { createAction, props } from '@ngrx/store';

export const initState = createAction('[Daily questionary] init', props<{questionaries: any[]}>());
export const loadDailyQuestionaries = createAction('[Daily questionary] load');
export const update = createAction('[Daily questionary] update', props<{orderId?, projectId, date, changes: any}>());
export const newQuestionary = createAction('[Daily questionary] newQuestionary', props<any>());

